import ReClassifier from './ReClassifier';

class ReClassifyAndMerge extends ReClassifier {
  constructor(mapObj: $TSFixMe) {
    super(mapObj, true);
  }
}

export default ReClassifyAndMerge;
